import { render, staticRenderFns } from "./Bahrain.vue?vue&type=template&id=c95fc2b8&"
import script from "./Bahrain.vue?vue&type=script&lang=js&"
export * from "./Bahrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c95fc2b8')) {
      api.createRecord('c95fc2b8', component.options)
    } else {
      api.reload('c95fc2b8', component.options)
    }
    module.hot.accept("./Bahrain.vue?vue&type=template&id=c95fc2b8&", function () {
      api.rerender('c95fc2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Bahrain.vue"
export default component.exports